import { Skeleton } from "@repo/design-system";

export function DataPageSkeleton() {
  return (
    <div className="flex min-h-[calc(100vh-6rem)] flex-col gap-6 bg-backgroundPrimary p-8">
      {/* Title row */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-8 w-56 rounded-lg" />
        <Skeleton className="h-10 w-36 rounded-lg" />
      </div>

      {/* Sidebar + table */}
      <div className="flex flex-1 gap-6">
        {/* Filter sidebar */}
        <div className="flex w-56 flex-shrink-0 flex-col gap-3 rounded-xl border border-borderPrimary p-4">
          <Skeleton className="h-5 w-20 rounded" />
          {Array.from({ length: 7 }).map((_, i) => (
            <Skeleton key={i} className="h-9 w-full rounded-lg" />
          ))}
        </div>

        {/* Table */}
        <div className="flex flex-1 flex-col gap-0 overflow-hidden rounded-xl border border-borderPrimary">
          <div className="flex gap-0 border-b border-borderPrimary bg-backgroundSecondary px-4 py-3">
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton key={i} className="mr-8 h-4 w-24 rounded" />
            ))}
          </div>
          {Array.from({ length: 8 }).map((_, i) => (
            <div
              key={i}
              className="flex gap-0 border-b border-borderPrimary px-4 py-3 last:border-b-0">
              {Array.from({ length: 5 }).map((_, j) => (
                <Skeleton key={j} className="mr-8 h-4 w-20 rounded" />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
